<template>
    <!-- <div v-if="useModule"> -->
    <div>
        <router-view name="dialog"></router-view>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    // data() {
    //     return {
    //     loading: true,
    //     useModule: true,
    //     }
    // },
    // async mounted() {
    //     await this.$store.dispatch("metaModule/fetchBetaFeature");
    //     this.useModule = this.$store.state.metaModule.betaFeatureOwnerAccess.feature.includes("INVOICE")
    // }
};
</script>
